import type { PhotoUploadPlan } from '../../lib/photoPipeline';
import { apiGet, apiDelete, apiPatch, apiUpload } from '../client';
import { BusinessPhotoSchema, BusinessPhotosResponseSchema, EmptyResponseSchema, type BusinessPhoto } from '../schemas';

export type UploadPhotoOptions = {
  position?: number;
  isPrimary?: boolean;
};

export function uploadBusinessPhoto(
  plan: PhotoUploadPlan,
  options: UploadPhotoOptions,
  idempotencyKey: string,
): Promise<BusinessPhoto> {
  const meta = {
    blurhash: plan.blurhash,
    variants: {
      original: { width: plan.original.width, height: plan.original.height },
      w480: { width: plan.w480.width, height: plan.w480.height },
      w960: { width: plan.w960.width, height: plan.w960.height },
      w1600: { width: plan.w1600.width, height: plan.w1600.height },
    },
    ...(options.position !== undefined ? { position: options.position } : {}),
    ...(options.isPrimary !== undefined ? { isPrimary: options.isPrimary } : {}),
  };

  const form = new FormData();
  form.append('original', plan.original.blob, 'original.jpg');
  form.append('w480', plan.w480.blob, 'w480.jpg');
  form.append('w960', plan.w960.blob, 'w960.jpg');
  form.append('w1600', plan.w1600.blob, 'w1600.jpg');
  form.append('meta', JSON.stringify(meta));

  return apiUpload('/v1/business/photos', BusinessPhotoSchema, form, idempotencyKey);
}

export type PatchPhotoInput = { position?: number; isPrimary?: boolean };

export function patchBusinessPhoto(
  photoId: string,
  input: PatchPhotoInput,
  idempotencyKey: string,
): Promise<BusinessPhoto> {
  return apiPatch(
    `/v1/business/photos/${encodeURIComponent(photoId)}`,
    BusinessPhotoSchema,
    input,
    idempotencyKey,
  );
}

export function deleteBusinessPhoto(photoId: string, idempotencyKey: string): Promise<undefined> {
  return apiDelete(
    `/v1/business/photos/${encodeURIComponent(photoId)}`,
    EmptyResponseSchema,
    idempotencyKey,
  );
}

export function listBusinessPhotos() {
  return apiGet('/v1/business/photos', BusinessPhotosResponseSchema);
}
